import { render, staticRenderFns } from "./miniMemberHome.vue?vue&type=template&id=77dea90e&scoped=true"
import script from "./miniMemberHome.vue?vue&type=script&lang=js"
export * from "./miniMemberHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dea90e",
  null
  
)

export default component.exports